import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/client'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Routes from './routes'
import store from './redux/storeConfig/store'
import setAuthToken from './utils/setAuthToken'
import { client } from './apollo/apollo'
import './index.css'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0da293',
    },
  },
})

// set token for axios requests
if (localStorage.token) {
  setAuthToken(localStorage.token)
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
    </Provider>
  </ApolloProvider>,

  document.getElementById('root')
)
